import { Grid, Typography, makeStyles } from "@material-ui/core";

import { ReportRunTerm } from "../../interface/ReportRunTerm";

const useStyles = makeStyles((theme) => ({
  term: {
    fontWeight: theme.typography.fontWeightBold as number,
  },
}));

/**
 * What the report means by its own words. Served with the run rather than written here,
 * so the definitions on screen are the ones the server applied. Plain by design — a
 * caller that wants it out of the way collapses it.
 */
const ReportTerms = ({ terms }: { terms: ReportRunTerm[] }) => {
  const classes = useStyles();

  if (terms.length === 0) return null;

  return (
    <Grid container spacing={2}>
      {terms.map((entry) => (
        <Grid item xs={12} sm={6} key={entry.term}>
          <Typography variant="subtitle2" className={classes.term}>
            {entry.term}
          </Typography>
          <Typography variant="caption" color="textSecondary" component="p">
            {entry.definition}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default ReportTerms;
